import { RootState } from '../../interfaces/rootState';

export const AuthSelector = ({ auth }: RootState) => auth;


